import actionTypes from "./actionTypes";

const defaultState = {
	id: "",
	title: "Aertech",
	description: "",
	language: "nl",
	showSocialMedia: false,
	cms: {
		title: "test",
		description: "adfa",
		buttonName: "",
		onClick: "",
	},
	navigation: undefined,
	utilities: {
		languages: [],
		translation: undefined,
	},
	consent: false,
};

function headReducer(state = defaultState, action) {
	switch (action.type) {
		case actionTypes.CHANGE_HEAD:
			return {
				...state,
				id: action.data.id,
				title: `Aertech ${action.data.title}`,
				description: action.data.description,
				showSocialMedia: action.data.showSocialMedia,
			};
		case actionTypes.NAVIGATION_CHANGE:
			return {
				...state,
				navigation: action.title,
			};
		case actionTypes.HEAD_CHANGE_LANGUAGE:
			return {
				...state,
				language: action.lang,
			};
		case actionTypes.HEAD_CHECK_LANGUAGE:
			return {
				...state,
				language: action.lang,
			};
		case actionTypes.SET_CMS_HEAD:
			return {
				...state,
				cms: {
					...action.data,
				},
			};
		case actionTypes.FETCH_LANGUAGE:
			return {
				...state,
				utilities: {
					...state.utilities,
					languages: action.data,
				},
			};
		case actionTypes.FETCH_LANGUAGE_FILES:
			return {
				...state,
				utilities: {
					...state.utilities,
					translation: action.data,
				},
			};
		case actionTypes.CHECK_CONSENT:
			return {
				...state,
				consent: action.consent,
			};
		case actionTypes.CONSET_TO_COOKIE:
			return {
				...state,
				consent: true,
			};
		case actionTypes.CHANGE_SOCIAL_MEDIA_VISIBILITY:
			return {
				...state,
				showSocialMedia: action.data,
			};
		default:
			return state;
	}
}

export default headReducer;



// WEBPACK FOOTER //
// ./src/redux/head/headReducer.js